import { VOUCHER_STATE } from './constants'

export const getVoucher = state => state[VOUCHER_STATE][VOUCHER_STATE] || {}
export const getIsFetching = state => state[VOUCHER_STATE].isFetching
export const getRefetch = state => state[VOUCHER_STATE].refetch
export const getEmail = state => state[VOUCHER_STATE].email
export const getPayNow = state => state[VOUCHER_STATE][VOUCHER_STATE]?.payNow
